module.exports = {
	"sv": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Sidan hittades inte",
				"title": "Sidan hittades inte",
				"details": "Applikationen du letar efter kunde inte hittas. Är du säker på att du skrev rätt adress?",
				"goBack": "Gå tillbaka"
			},
			"activation": {
				"pageTitle": "Säker Zon",
				"title": "Välkommen till den säkra zonen",
				"activate": {
					"details": "En sekund, vi förbereder din aktiveringslänk...",
					"ready": "Din länk är färdig. Klicka på knappen för att fortsätta. Observera att koden bara kan användas en gång!",
					"go": "Aktivera konto"
				},
				"passwordReset": {
					"details": "En sekund, vi förbeder din länk för att återställa lösenord...",
					"ready": "Din länk är färdig. Klicka på knappen för att fortsätta. Observera att koden bara kan användas en gång!",
					"go": "Återställ lösenord"
				},
				"error": {
					"details": "Det verkar som att något är fel med din länk. Vänligen försök igen eller kontakta kundtjänst med koden som referens."
				}
			},
			"privacy-policy": {
				"pageTitle": "Sekretesspolicy för Butiksportalen"
			},
			"terms-and-conditions": {
				"pageTitle": "Avtal för Butiksportalen"
			},
			"Support": {
				"pageTitle": "Support",
				"topic": {
					"orders": "Beställningar",
					"settlements": "Avräkningar",
					"agreements": "Avtal",
					"technical_issues": "Tekniska problem",
					"others": "Övriga"
				},
				"TicketList": {
					"title": "Supportärenden",
					"pageDescription": "Här kan du se status för dina supportärenden",
					"status": {
						"open": "Öppna",
						"pending": "Väntande",
						"resolved": "Löst",
						"closed": "Avslutad",
						"inProgress": "Pågående",
						"waitingForYourReply": "Väntar på ditt svar"
					},
					"TicketTable": {
						"id": "Ärende #",
						"mid": "Butik/MID",
						"subject": "Ämne",
						"status": "Status",
						"updatedAt": "Senast uppdaterad"
					}
				},
				"EmptyTicketList": {
					"title": "Du har inga öppna ärenden"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Användare"
						},
						"details": {
							"title": "Uppgifter",
							"store": "Butik/MID",
							"createdAt": "Datum för förfrågan",
							"updatedAt": "Senast uppdaterad"
						},
						"actions": {
							"close": "Stäng förfrågan",
							"reopen": "Öppna förfrågan på nytt"
						},
						"closeTicketDialog": {
							"confirm": "Bekräfta",
							"title": "Stäng förfrågan",
							"description": "Du håller på att stänga en förfrågan. Du kan endast öppna den på nytt inom de närmaste 7 dagarna.",
							"error": "Oj! Något gick fel. Försök igen."
						},
						"reopenTicketDialog": {
							"title": "Öppna förfrågan på nytt",
							"description": "Berätta varför du behöver öppna denna förfrågan på nytt så återkommer vi snart.",
							"messageLabel": "Meddelande"
						}
					},
					"conversation": {
						"loadMore": "Ladda fler",
						"title": "Förfrågan",
						"attachments": {
							"label": "Bilagor"
						},
						"reply": {
							"title": "Lägg till svar",
							"body": {
								"label": "Lägg till ett svar",
								"error": null
							},
							"attachment": {
								"label": "Lägg till bilaga",
								"error": "Total filstorlek måste vara under 15 MB"
							},
							"add": "Lägg till svar",
							"cancel": "Avbryt",
							"submit": {
								"label": "Skicka",
								"error": "Kunde inte spara svar. Försök igen senare"
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Oj!",
						"message": "Något gick fel. Försök igen om några minuter. Om problemet kvarstår, kontakta oss för hjälp.",
						"contact": "När du kontaktar butikssupport, vänligen ange följande korrelations-ID:",
						"action": "Kontakta oss"
					},
					"error": "Fel",
					"default": {
						"title": "Oj, något gick fel",
						"message": "Av någon anledning kunde vi inte behandla din förfrågan. Försök igen eller kom tillbaka senare.",
						"contact": "När du kontaktar butikssupport, vänligen ange följande korrelations-ID:",
						"action": "Uppdatera"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Grab and Go-marknadsföring",
				"banner": {
					"title": "Välkommen till Grab and Go-marknadsföring!",
					"subtitle": "Här hittar du färdiga filer för din webbsida, dina e-postkampanjer och sociala medier.",
					"button": "Läs mer"
				},
				"productSection": {
					"title": "Vilka Klarnaprodukter erbjuder du kunder?"
				},
				"MarketSelector": {
					"label": "Välj marknad",
					"markets": {
						"BE": "Belgien (holländska)",
						"BE-FR": "Belgien (franska)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 Delbetalningar",
						"pin30": "Betala inom 30 dagar"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Behöver du hjälp med detta?",
					"copyButton": "Kopiera till urklipp",
					"copyButtonSuccess": "Kopierad!",
					"sourceButton": "Källa",
					"previewButton": "Förhandsgranska"
				},
				"EmailTemplates": {
					"pageTitle": "E-postmallar",
					"title": "E-postmallar"
				},
				"EmailHeader": {
					"pageTitle": "Bild för e-postmarknadsföring",
					"title": "Bild för e-postmarknadsföring"
				},
				"Social": {
					"pageTitle": "Sociala medier",
					"title": "Sociala medier"
				},
				"buttonDownload": "Ladda ner bild",
				"buttonCopy": "Kopiera text",
				"buttonCopySuccess": "Kopierad!",
				"missingPreview": "Saknar förhandsgranskning",
				"productLinkText": "Hämta nu",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "En komplett kassalösning med allt på ett och samma ställe."
						},
						"payNow": {
							"title": "Betala nu",
							"subtitle": "Låt kunder betala för sina köp med en gång."
						},
						"threeInstallments": {
							"title": "3 delbetalningar",
							"subtitle": "Låt kunder dela upp kostnaden räntefritt över tid."
						},
						"fourInstallments": {
							"title": "4 Delbetalningar",
							"subtitle": "Låt kunder dela upp kostnaden räntefritt över tid."
						},
						"pin14": {
							"title": "Betala sen",
							"subtitle": "Betala inom 14 dagar. Inga räntor eller avgifter."
						},
						"pin21": {
							"title": "Betala om 21 dagar",
							"subtitle": "Betala inom 21 dagar. Inga räntor eller avgifter."
						},
						"pin30": {
							"title": "Betala inom 30 dagar",
							"subtitle": "Betala inom 30 dagar. Inga räntor eller avgifter."
						},
						"financing": {
							"title": "Dela upp",
							"subtitle": "Öka din försäljning genom att erbjuda betalning upp till 36 månader."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Jul 2020",
							"channels": {
								"emailHeader": {
									"title": "Bild för e-postmarknadsföring",
									"subtitle": "Fånga dina prenumeranters uppmärksamhet under julen med dessa bilder i studiokvalitet för dina e-postkampanjer.",
									"linkText": "Se bilder",
									"introduction": "Det är dags att berätta för dina prenumeranter om dina fantastiska julerbjudanden och -rabatter! Ladda ner en bild och använd den i en e-postkampanj eller i sidhuvudet för störst effekt."
								},
								"social": {
									"title": "Sociala medier",
									"subtitle": "Få fler kunder till din butik under jul med dessa gratisbilder.",
									"linkText": "Se inlägg",
									"introduction": "Det är dags att marknadsföra dina fantastiska julerbjudanden och -rabatter! Ladda ner filerna och använd dem direkt på dina profiler eller i ditt verktyg för sociala medier. Kom ihåg att tagga {link} i din marknadsföring för ännu fler kunder och konverteringar."
								}
							},
							"imageAlt": {
								"holiday1": "Personen i blå och rosa overall glider på ett knä mot en mopp. Ena armen håller en silversko och den andra en smartphone.",
								"holiday2": "Personen i vinröd satinpyjamas sitter med benen i kors och svävar över en fläkt med en smartphone svävandes i ögonhöjd."
							}
						},
						"at-launch": {
							"title": "Vid lansering",
							"subtitle": "Precis börjat din resa med oss? Använd dessa filer för att meddela nya och gamla kunder att du är live med Klarna.",
							"channels": {
								"email": {
									"title": "E-postmallar",
									"subtitle": "Låt dina prenumeranter veta att det finns ett nytt sätt att betala i kassan.",
									"linkText": "Se mallar",
									"introduction": "Det är dags att meddela dina prenumeranter att du har lanserat Klarna! Kopiera och klistra in mallen eller innehållet på din e-postplattform så är det klart.",
									"codeBoxTitle": "Lanseringsmeddelande"
								},
								"social": {
									"title": "Sociala medier",
									"subtitle": "Få fler kunder till din butik med smoooth bilder i studiokvalitet.",
									"linkText": "Se inlägg",
									"introduction": "Det är dags att meddela världen att du har lanserat Klarna! Ladda ner filerna och använd dem direkt på dina profiler eller i ditt verktyg för sociala medier. Kom ihåg att tagga {link} i dina meddelanden för ännu fler kunder och konverteringar."
								},
								"osm": {
									"title": "Landningssida",
									"subtitle": "Följ reglerna och informera kunder om hur du handlar med Klarna.",
									"linkText": "Se sidor"
								}
							},
							"imageAlt": {
								"emotional": "Person med långt, lockigt hår i lila jumpsuit som spelar på en flippermaskin",
								"paymentShowcase": "En hand som håller en telefon som visar Klarnalogotypen, rullskridskor i bakgrunden",
								"simplified": "Telefon vänd nedåt på en flippermaskin till höger, ljusgul soffa till vänster",
								"device": "En telefon som visar Klarnalogotypen hängande från sidan, rosa rum med ljuskrona i bakgrunden"
							}
						}
					}
				}
			}
		}
	}
};